export default __webpack_public_path__ + "static/media/flocker.5815a02f.svg";